const inflight = new Map()
export const MEMBER_PROFILE_TIMEOUT_MS = 1800
export const MEMBER_PROFILE_RETRY_DELAY_MS = 150

function transient(error) {
  return error?.name === 'TimeoutError' || error?.name === 'TypeError' || Number(error?.status) >= 500
}

function delay(ms) { return new Promise((resolve) => setTimeout(resolve, ms)) }

async function attempt(fetchProfile, timeoutMs) {
  const controller = new AbortController()
  let rejectTimeout
  const timeoutPromise = new Promise((_, reject) => { rejectTimeout = reject })
  const timeout = setTimeout(() => {
    controller.abort('timeout')
    const timeoutError = new Error('member_profile_timeout')
    timeoutError.name = 'TimeoutError'
    rejectTimeout(timeoutError)
  }, timeoutMs)
  try {
    const response = await Promise.race([fetchProfile(controller.signal), timeoutPromise])
    if (!response.ok) {
      const error = new Error(`profile_http_${response.status}`)
      error.status = response.status
      throw error
    }
    return response
  } catch (error) {
    if (controller.signal.aborted && controller.signal.reason === 'timeout' && error?.name !== 'TimeoutError') {
      const timeoutError = new Error('member_profile_timeout')
      timeoutError.name = 'TimeoutError'
      throw timeoutError
    }
    throw error
  } finally { clearTimeout(timeout) }
}

/** One shared, bounded profile refresh per exact club/subject identity. */
export function requestMemberProfile({ key, fetchProfile, timeoutMs = MEMBER_PROFILE_TIMEOUT_MS, retryDelayMs = MEMBER_PROFILE_RETRY_DELAY_MS }) {
  if (inflight.has(key)) return inflight.get(key)
  const promise = (async () => {
    try { return await attempt(fetchProfile, timeoutMs) }
    catch (error) {
      if (!transient(error)) throw error
      await delay(retryDelayMs)
      return attempt(fetchProfile, timeoutMs)
    }
  })().finally(() => inflight.delete(key))
  inflight.set(key, promise)
  return promise
}

export function clearMemberProfileRequestsForTests() { inflight.clear() }

// Separate reads after mutations from snapshots already in flight, across remounts.
let profileReadRevision = 0
export function nextProfileReadRevision() { return ++profileReadRevision }
